export default __webpack_public_path__ + "static/media/modalTopBg.2f53d4d1.png";